import { supabase } from '../supabase.js'
import { TEMPLATE_LIBRARY_SCOPE } from './serverIndicatorTemplates.js'
const checked = result => { if (result.error) throw result.error; return result.data }
export function templateLibraryTransport(userId, client = supabase, scope = TEMPLATE_LIBRARY_SCOPE) {
  const bounded = query => query.abortSignal(AbortSignal.timeout(10000))
  return {
    async read() {
      const rows = checked(await bounded(client.from('user_chart_preferences').select('preference_key,preferences')
        .eq('user_id', userId).eq('scope', scope))) || []
      return Object.fromEntries(rows.map(row => {
        if (row.preferences?.version !== 1 || typeof row.preferences.revision !== 'string' || !row.preferences.template) throw Error('Invalid template record')
        return [row.preference_key, row.preferences]
      }))
    },
    async write(id, preferences, revision) {
      const row = { user_id: userId, scope, preference_key: id, preferences, updated_at: new Date().toISOString() }
      if (revision === null) {
        const result = await bounded(client.from('user_chart_preferences').insert(row).select('preference_key'))
        if (result.error?.code === '23505') return false
        return (checked(result) || []).length === 1
      }
      return (checked(await bounded(client.from('user_chart_preferences').update({ preferences, updated_at: row.updated_at })
        .eq('user_id', userId).eq('scope', scope).eq('preference_key', id)
        .eq('preferences->>revision', revision).select('preference_key'))) || []).length === 1
    },
  }
}
